import { render, staticRenderFns } from "./Vca.vue?vue&type=template&id=418a7a17"
import script from "./Vca.vue?vue&type=script&lang=ts"
export * from "./Vca.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports